<!--
 * @Descripttion: 
 * @version: 
 * @Author: Francis
 * @Date: 2022-07-26 22:33:18
 * @LastEditors: Francis
 * @LastEditTime: 2022-07-27 01:39:17
-->
<template>
  <div class="accountant-business">
    <!-- 头部信息 -->
    <HeaderSearch
      :keyWord.sync="keyWord"
      pageName="审核"
      tip="船名、手机号、AIS识别码查询"
      :dispatchOrder="dispatchOrder"
      @updatekeyWord="updatekeyWord"
      @updataState="updataState"
    ></HeaderSearch>
    <!-- 列表部分 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="listbox">
          <div class="listitem" v-for="(item, index) in list" :key="index">
            <div class="itemstyle">
              <div class="title">
                <div class="left">
                  <img src="@/assets/dispatch/toExamine/iconheard.png" alt="" />
                  {{ item.shipName }}
                </div>
                <div class="right">
                  <span> {{ item.identificationNumber }}</span>
                </div>
              </div>
              <div class="msg">
                <div class="msgitem" style="width: 60%">
                  <span class="lable">AIS识别码：</span>
                  <span>{{ item.mmsi ? item.mmsi : "--" }}</span>
                </div>
                <div class="msgitem" style="width: 40%">
                  <img src="@/assets/dispatch/toExamine/phon.png" alt="" />
                  <span>{{ item.phone }}</span>
                </div>
                <div class="msgitem" style="width: 100%">
                  <span class="lable">申请时间：</span>
                  <span>{{ item.applyTime }}</span>
                </div>
              </div>

              <div class="end">
                <div class="buttomstyle" @click="gotoExamine(item.id)">
                  {{ item.state == 1 ? "审核" : "查看详情" }}
                </div>
                <div class="imgstate" v-if="state == ''">
                  <img :src="geticon(item.state)" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import HeaderSearch from "@/components/HeaderSearch";
import dispatchReciveOrder from "./components/dispatchReciveOrder";
import dispatchUnreciveOrder from "./components/dispatchUnreciveOrder";
import { verifyshiplist } from "@/utils/network/toExamine";
export default {
  name: "shipowner",
  components: {
    HeaderSearch,
    dispatchReciveOrder,
    dispatchUnreciveOrder,
  },
  props: {},
  data() {
    return {
      // 顶部搜索框
      keyWord: "",
      // tabs
      dispatchOrder: [
        {
          text: "未审核",
          state: 1,
        },
        {
          text: "已驳回",
          state: 3,
        },
        {
          text: "已通过",
          state: 2,
        },
        {
          text: "全部",
          state: "",
        },
      ],
      state: 1,
      // 下拉刷新
      refreshing: false,
      loading: true,
      finished: false,
      list: [],
      pageNum: 1,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getlistmsg();
  },
  methods: {
    updatekeyWord(e) {
      this.keyWord = e;
      this.pageNum = 1;
      this.list = [];
      this.getlistmsg();
    },
    updataState(e) {
      this.state = e;
      this.pageNum = 1;
      this.list = [];
      this.keyWord = "";
      this.finished = false;
      this.loading = true;
      this.getlistmsg();
    },
    // 下拉刷新
    onRefresh() {
      console.log("刷新");
      this.refreshing = false;
      this.loading = true;
      this.pageNum = 1;
      this.list = [];
      this.getlistmsg();
    },
    // 上拉加载下一页
    onLoad() {
      this.getlistmsg();
    },
    // 跳转
    gotoExamine(id) {
      this.$router.push({
        path: "/dispatch/toExamine/toExamine",
        query: { id },
      });
    },
    getlistmsg() {
      verifyshiplist({
        state: this.state,
        searchValue: this.keyWord,
        pageNum: this.pageNum,
      }).then((res) => {
        console.log(res, res.pageCount, this.pageNum);
        console.log("触发", res.pageCount >= this.pageNum);
        if (res.pageCount >= this.pageNum) {
          res.rows.filter((v) => {
            this.list.push(v);
          });
          this.loading = false;
          this.finished = false;
          this.refreshing = false;
          this.pageNum++;
        } else {
          this.loading = false;
          this.finished = true;
        }
      });
    },
    // 返回图片
    geticon(status) {
      switch (status) {
        case 1:
          return require("@/assets/dispatch/toExamine/Unaudited.png");
        case 2:
          return require("@/assets/dispatch/toExamine/Passed.png");
        case 3:
          return require("@/assets/dispatch/toExamine/Rejected.png");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.accountant-business {
  padding-top: 150px;
  height: 100vh;
  background: #eeeeee;

  .listbox {
    padding: 0 16px;
    .listitem {
      border-radius: 5px;
      margin-bottom: 12px;
      .itemstyle {
        background: #ffffff;
        border-radius: 4px;
        padding: 8px;

        .title {
          padding: 6px 0 10px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid #eeeeee;
          .left {
            display: flex;
            align-items: center;

            font-weight: 600;
            color: #333333;
            img {
              width: 20px;
              height: 20px;
              margin-right: 10px;
            }
          }
          .right {
            font-size: 16px;
            font-weight: 600;
            color: #0e93ff;
          }
        }
        .msg {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 12px 0;
          .msgitem {
            width: 50%;
            margin: 8px 0;
            font-size: 14px;
            display: flex;
            align-items: center;
            img {
              width: 20px;
              height: 20px;
              margin-right: 3px;
            }
            .lable {
              font-weight: 400;
              text-align: center;
              color: #999999;
              line-height: 20px;
            }
          }
        }

        .end {
          border-top: 1px solid #eeeeee;
          padding: 10px 0 0 0;
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          justify-content: space-between;
          .buttomstyle {
            padding: 7px 13px;
            background: #44b2f9;
            color: #ffffff;
            font-size: 14px;
            border-radius: 8px;
          }
          .imgstate {
            img {
              width: 47px;
              height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
